module.exports = __webpack_public_path__ + "assets/img/login-logo@3x.4c628639.png";